export default {
  white: `#fff`,
  black: `#222`,
}
